import api from '@/utilities/api'
export const newAlert = ({ commit, dispatch }, payload) => {
  commit('newAlert', payload)
}
export const hideAlert = ({ commit, dispatch }, payload) => {
  commit('hideModal', payload)
}
export const newNotification = ({ commit, dispatch }, payload) => {
  commit('newNotification', payload)
}
export const hideTopBar = ({ commit, dispatch }, payload) => {
  commit('hideNotification', payload)
}
export const setValidation = ({ commit, dispatch }, payload) => {
  commit('setValidation', payload)
}
export const createTestRecords = ({ commit, dispatch }, payload) => {
  payload = {
    records: payload
  }
  return api.request({
    method: 'post',
    endpoint: 'private/utilities/createTestRecords',
    payload
  })
}
